/**
 * Model object to store information related to a Segment of a Slice
 */
class ItineraryReferenceInfoObj {
  constructor() {
    this.itineraryReferenceKey = ''
    this.candidateKey = ''
    this.groupId = ''
    this.refId = ''
    this.pricedConfirmationId = ''
    this.itineraryTypeCode = ''
    this.ticketType = ''
  }

  getItineraryReferenceKey() {
    return this.itineraryReferenceKey
  }

  setItineraryReferenceKey(itineraryReferenceKey) {
    this.itineraryReferenceKey = itineraryReferenceKey
  }

  getCandidateKey() {
    return this.candidateKey
  }

  setCandidateKey(candidateKey) {
    this.candidateKey = candidateKey
  }

  getGroupId() {
    return this.groupId
  }

  setGroupId(groupId) {
    this.groupId = groupId
  }

  getRefId() {
    return this.refId
  }

  setRefId(refId) {
    this.refId = refId
  }

  getPriceConfirmationId() {
    return this.pricedConfirmationId
  }

  setPriceConfirmationId(pricedConfirmationId) {
    this.pricedConfirmationId = pricedConfirmationId
  }

  getItineraryTypeCode() {
    return this.itineraryTypeCode
  }

  setItineraryTypeCode(itineraryTypeCode) {
    if (itineraryTypeCode === 'ONE_WAY') {
      this.itineraryTypeCode = 'OW'
    } else if (itineraryTypeCode === 'MULTI_DESTINATION') {
      this.itineraryTypeCode = 'MD'
    } else if (itineraryTypeCode === 'ROUND_TRIP') {
      this.itineraryTypeCode = 'RT'
    } else if (itineraryTypeCode) {
      this.itineraryTypeCode = itineraryTypeCode
    }
  }

  getTicketType() {
    return this.ticketType
  }

  setTicketType(ticketType) {
    this.ticketType = ticketType
  }

  update(rawItineraryInfo) {
    this.setGroupId(rawItineraryInfo.groupId)
    this.setRefId(rawItineraryInfo.refId)
    this.setItineraryReferenceKey(rawItineraryInfo.itinRefKey)
  }
}

export { ItineraryReferenceInfoObj }
